(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/prescript.js'); 
(function(svs) {
  'use strict';

  svs = svs || {};
  svs.maltipset = svs.maltipset || {};

  svs.maltipset.views = svs.maltipset.views || {};
  svs.maltipset.models = svs.maltipset.models || {};
  svs.maltipset.collections = svs.maltipset.collections || {};
  svs.maltipset.objects = svs.maltipset.objects || {};
  svs.maltipset.helpers = svs.maltipset.helpers || {};
  svs.maltipset.controllers = svs.maltipset.controllers || {};

  svs.maltipset.constants = {
    FACT_OF_EIGHT: 40320,
    STORAGE_ID: 'coupon',

    NUMBER_OF_ROWS_NOSYSTEM:
      svs.utils.ns.isNamespace(
        'svs.core.config.data.svsconfig.isSelfService'
      ) && svs.core.config.data.svsconfig.isSelfService === true
        ? 12
        : 14,

    NUMBER_OF_MATCHES: 30,
    NUMBER_OF_MATCHES_TO_SELECT_NOSYSTEM: 8,
    NUMBER_OF_MATCHES_TO_SELECT_MSYSTEM_MIN: 9,
    NUMBER_OF_MATCHES_TO_SELECT_RSYSTEM_MIN: 11,
    NUMBER_OF_MATCHES_TO_SELECT_SYSTEM_MAX: 14,

    ONE_ROW_COST: 2.5,
    MAX_TTT_RATING: 10,
    VALID_SPORTKRYSS_LENGTH: 7,
    SYSTEM: {
      M_SYSTEM: 'msystem',
      R_SYSTEM: 'rsystem',
      NO_SYSTEM: 'nosystem'
    },
    ACTIONBARS: {
      NO_BAR: 0,
      XPERT: 1,
      SYSTEM: 2,
      BASEROW: 3,
      TIPSINFO: 4
    },
    XPERT_PROPERTIES: {
      WEIGHTEDQP: 'WEIGHTEDQP',
      MODIFIEDQP: 'MODIFIEDQP',
      PARTIALQP: 'PARTIALQP',
      NOXPERT: 'NOEXPERT'
    },
    BET_PROPERTIES: {
      MARKETPLACE: 'GROUP',
      PROLONGATION: 'PROLONGATION'
    },
    SPORT_ID: {
      SOCCER: 1000002
    },
    START_PAGE: {
      BRANDING: 'maltipset',
      DEFAULT_NO_OPEN_DRAWS_INFO:
        'Inga öppna omgångar för tillfället. <br />Återkom om en kort stund.',
      DEFAULT_NO_OPEN_DRAWS_INFO_START: 'Inga öppna omgångar för tillfället.',
      DEFAULT_NO_OPEN_DRAWS_INFO_END: 'Återkom om en kort stund.'
    }
  };
})(svs);

 })(window);